export default {"src":"/_next/static/image/public/images/ic_location_icon.0aefcc4c37f71e5a6b6d27b24da3a104.svg","height":24,"width":24};